import React, { PureComponent, Fragment } from 'react'
import { Grid, ListItem, MenuItem } from '@material-ui/core'
import { forEveryKey } from '../../utils/array'
import {
  onChangeEditHOF,
  toPercentage,
  tryConvertToFixed,
  convertToFixed,
} from '../../utils/common'
import { TaxProcessingOrderOptions } from '../../utils/constants'
import { EditableNumericInput, EditableSelect, EditableSwitch } from '../common/EditableComponents'
import FormControlWithEditableInput from '../common/FormControlWithEditableInput'

export default class RegularTaxOptions extends PureComponent {
  TaxProcessingOrderMenuItems = forEveryKey(TaxProcessingOrderOptions, (value, label) => (
    <MenuItem value={value} key={value}>
      {label}
    </MenuItem>
  ))

  updateTaxInfo = (key, value, isToggle) => {
    if (!isToggle && 0 > value) {
      return
    }

    if (isToggle) {
      let e = value
      value = e.target.checked
    }

    let taxInfo = { ...this.props.data.taxInfo }

    if (isToggle) {
      taxInfo = {
        ...taxInfo,
        [key]: value,
      }
    } else {
      taxInfo = {
        ...taxInfo,
        [key]: value / 100,
      }
    }
    this.props.onChange('taxInfo', taxInfo)
  }

  onChange = onChangeEditHOF(this.props.onChange)

  onChangeTax = onChangeEditHOF(this.updateTaxInfo)

  getTaxRateValue = (taxRateInDecimal) => {
    return taxRateInDecimal ? parseFloat(convertToFixed(taxRateInDecimal * 100.0, 4)) : 0.0
  }

  onKeyDown = (e) => {
    if (
      e.keyCode !== 8 &&
      e.keyCode !== 37 &&
      e.keyCode !== 39 &&
      e.target.selectionStart === (e.target.value || '').length &&
      e.target.selectionStart === e.target.selectionEnd &&
      e.target.value > 0
    ) {
      e.preventDefault()
      return false
    }
  }

  render() {
    let { data = {}, editMode = false, isCDTFAEnabled = false } = this.props

    let { taxInfo = {} } = data
    const selectedTaxOrder = TaxProcessingOrderOptions[data.taxOrder]
    const cityTax = this.getTaxRateValue(taxInfo.cityTax)
    const stateTax = this.getTaxRateValue(taxInfo.stateTax)
    const federalTax = this.getTaxRateValue(taxInfo.federalTax)
    const activeCDTFATax = taxInfo.activeCDTFATax
    return (
      <Fragment>
        <ListItem>
          <Grid container>
            <Grid item lg={6}>
              Tax Processing Order
            </Grid>
            <Grid item lg={6}>
              <EditableSelect
                value={data && data.taxOrder}
                valueToRender={selectedTaxOrder}
                onChange={this.onChange('taxOrder')}
                editMode={editMode}
              >
                {this.TaxProcessingOrderMenuItems}
              </EditableSelect>
            </Grid>
          </Grid>
        </ListItem>
        {isCDTFAEnabled && (
          <ListItem>
            <Grid container>
              <Grid item lg={6}>
                Enable CDTFA State Tax
              </Grid>
              <Grid item lg={6}>
                <EditableSwitch
                  valueToRender={activeCDTFATax ? 'Yes' : 'No'}
                  checked={activeCDTFATax}
                  editMode={editMode}
                  onChange={(e) => this.updateTaxInfo('activeCDTFATax', e, true)}
                />
              </Grid>
            </Grid>
          </ListItem>
        )}
        <ListItem>
          <Grid container>
            <Grid item lg={3}>
              Shop Taxes
            </Grid>
            <Grid item lg={9}>
              <Grid container>
                <Grid item lg={4} style={{ padding: '0 15px 0 15px' }}>
                  <p>City tax</p>
                  <EditableNumericInput
                    placeholder="City tax"
                    valueToRender={cityTax}
                    value={cityTax}
                    className="numeric-material-input"
                    mobile={false}
                    onChange={(e) => this.updateTaxInfo('cityTax', e)}
                    min={0}
                    step={0.0001}
                    strict
                    precision={4}
                    editMode={editMode}
                    onKeyDown={this.onKeyDown}
                  />
                </Grid>
                <Grid item lg={4} style={{ padding: '0 15px 0 15px' }}>
                  <p>State tax</p>
                  <EditableNumericInput
                    placeholder="State tax"
                    editMode={editMode}
                    valueToRender={stateTax}
                    value={stateTax}
                    className="numeric-material-input"
                    mobile={false}
                    onChange={(e) => this.updateTaxInfo('stateTax', e)}
                    min={0}
                    step={0.0001}
                    strict
                    precision={4}
                    onKeyDown={this.onKeyDown}
                  />
                </Grid>
                <Grid item lg={4} style={{ padding: '0 15px 0 15px' }}>
                  <p>Federal tax</p>
                  <EditableNumericInput
                    placeholder="Federal tax"
                    editMode={editMode}
                    valueToRender={federalTax}
                    value={federalTax}
                    className="numeric-material-input"
                    mobile={false}
                    onChange={(e) => this.updateTaxInfo('federalTax', e)}
                    min={0}
                    step={0.0001}
                    strict
                    precision={4}
                    onKeyDown={this.onKeyDown}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </ListItem>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/TaxOption/RegularTaxOption.js